import clsx from 'clsx';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import styles from './ToastContainer.module.scss';

export const notify = (notification: string | JSX.Element, type: 'success' | 'error') => {
  toast[type](notification, {
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    className: clsx(styles.toastBody, type === 'success' ? styles.toastBodySuccess : styles.toastBodyError),
  });
};
